import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Doughnut } from 'react-chartjs-2';
import CustomBetsCardMade from './CustomBetsCardMade'
import CustomBetsCardTaken from './CustomBetsCardTaken'
import CustomBetsCard from './CustomBetsCard'
import CancelCustomWager from './customWagerStages/CancelCustomWager'
import SubmitVote from './customWagerStages/SubmitVote'
import Countdown from 'react-countdown-now';
import { Tabs } from 'antd';

@observer(["ViewStore", "UserStore"])
class MyCustomBetStaging extends Component {
    constructor(props) {
        super(props);
        this.state = {
            renderedMadeCustomWagerList: [],
            renderedTakenCustomWagerList: [],
            loadedWagers: false,
        };
        this.renderAllCustomWagersAtOnce = this.renderAllCustomWagersAtOnce.bind(this);
        this.renderCustomWagersComponents = this.renderCustomWagersComponents.bind(this);
        this.renderCustomWagersComponent = this.renderCustomWagersComponent.bind(this);
        this.renderStage = this.renderStage.bind(this);
    }

    async componentWillMount() {
        let self = this;
        setTimeout(() => { self.renderAllCustomWagersAtOnce(); }, 950)
        setTimeout(() => { self.setState({ loadedWagers: true }); }, 1050)
    }

    renderAllCustomWagersAtOnce() {
        const { UserStore } = this.props;

        let customWagerListMade = [];
        let customWagerListTaken = [];
        let customWagersAllObjectList = [];

        let stageWagersMade = [{ "takerETHAddress": "0xd82e8bfc243d141105f540823290102de1c61477", "paidOut": false, "_id": "5c1d3ef023510f180c46cb5e", "bytes32Id": "0x3e2eb6b7857a8334c9f5d0db9dcfa2457ad5848f14c868db0dec507f6e5e6c3e", "maker": "5c1a86de396e971564c34b0a", "makerETHAddress": this.props.UserStore.user.publicAddress, "judge": "0x0000000000000000000000000000000000000000", "value": 0.05, "odds": 100, "endTime": 1546370903.932, "reportingEndTime": 1546457303.934, "outcomeOne": "I will guess your birthday", "outcomeTwo": "No you won't", "makerChoice": 1, "takerChoice": 2, "settled": false, "cancelled": false, "createdAt": "2018-12-21T19:28:48.150Z", "updatedAt": "2018-12-21T19:30:04.436Z", "__v": 0, "taker": "Buzz1man" }]
        let stageWagersTaken = [{ "takerETHAddress": this.props.UserStore.user.publicAddress, "paidOut": false, "_id": "5c1d44a123510f180c46cb5f", "bytes32Id": "0x7b82136a5bb0d588336bf5bfdac2ce00eb5018d32abb77a7d6e25436169eabf8", "maker": "5c1a84a03dbc7f2e101ff6a5", "makerETHAddress": "0xd82e8bfc243d141105f540823290102de1c61477", "judge": "0x0000000000000000000000000000000000000000", "value": 0.05, "odds": 100, "endTime": 1546372365.436, "reportingEndTime": 1546458765.44, "outcomeOne": "Toronto Maple Leafs Will Win", "outcomeTwo": "No They will not", "makerChoice": 1, "takerChoice": 2, "settled": false, "cancelled": false, "createdAt": "2018-12-21T19:53:05.056Z", "updatedAt": "2018-12-21T19:55:19.792Z", "__v": 0, "taker": "Exec1Mega" }]
        let timeNowValue = Date.now() / 1000;

        for (let customWager of stageWagersMade) {
            customWagerListMade.push(customWager);
        }

        for (let customWager of stageWagersTaken) {
            customWagerListTaken.push(customWager);
        }

        for (let customWager of customWagerListMade) {
            if (customWager.cancelled) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "cancelled"
                });
            } else if (customWager.taker == "" && timeNowValue < customWager.endTime) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "untaken-pre-end-time"
                });
            } else if (customWager.taker == "" && timeNowValue > customWager.endTime) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "untaken-post-end-time"
                });
            } else if (customWager.taker !== "" && (timeNowValue < customWager.endTime) && (timeNowValue < customWager.reportingEndTime) && customWager.makerWinVote == 0 && customWager.takerWinVote == 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "no-votes-pre-end-time-pre-reporting-end-time"
                });
            } else if (customWager.taker !== "" && (timeNowValue > customWager.endTime) && (timeNowValue < customWager.reportingEndTime) && customWager.makerWinVote == 0 && customWager.takerWinVote == 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "no-votes-post-end-time-pre-reporting-end-time"
                });
            } else if (customWager.taker !== "" && (timeNowValue > customWager.endTime) && (timeNowValue > customWager.reportingEndTime) && customWager.makerWinVote == 0 && customWager.takerWinVote == 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "no-votes-post-end-time-post-reporting-end-time"
                });
            } else if (customWager.taker !== "" && (timeNowValue < customWager.endTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote == 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "only-maker-voted-pre-end-time"
                });
            } else if (customWager.taker !== "" && (timeNowValue < customWager.endTime) && customWager.makerWinVote == 0 && customWager.takerWinVote !== 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "only-taker-voted-pre-end-time"
                });
            } else if (customWager.taker !== "" && (timeNowValue < customWager.endTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote !== 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "maker-taker-voted-pre-end-time"
                });
            } else if (customWager.taker !== "" && (timeNowValue > customWager.endTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote == 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "only-maker-voted-post-end-time"
                });
            } else if (customWager.taker !== "" && (timeNowValue > customWager.endTime) && customWager.makerWinVote == 0 && customWager.takerWinVote !== 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "only-taker-voted-post-end-time"
                });
            } else if (customWager.taker !== "" && (timeNowValue > customWager.endTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote !== 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "maker-taker-voted-post-end-time"
                });
            } else if (customWager.taker !== "" && (timeNowValue > customWager.endTime) && (timeNowValue < customWager.reportingEndTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote == 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "only-maker-voted-pre-reporting-end-time"
                });
            } else if (customWager.taker !== "" && (timeNowValue > customWager.endTime) && (timeNowValue < customWager.reportingEndTime) && customWager.makerWinVote == 0 && customWager.takerWinVote !== 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "only-taker-voted-pre-reporting-end-time"
                });
            } else if (customWager.taker !== "" && (timeNowValue > customWager.endTime) && (timeNowValue < customWager.reportingEndTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote !== 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "maker-taker-voted-pre-reporting-end-time"
                });
            } else if (customWager.taker !== "" && (timeNowValue > customWager.endTime) && (timeNowValue > customWager.reportingEndTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote == 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "only-maker-voted-post-reporting-end-time"
                });
            } else if (customWager.taker !== "" && (timeNowValue > customWager.endTime) && (timeNowValue > customWager.reportingEndTime) && customWager.makerWinVote == 0 && customWager.takerWinVote !== 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "only-taker-voted-post-reporting-end-time"
                });
            } else if (customWager.taker !== "" && (timeNowValue > customWager.endTime) && (timeNowValue > customWager.reportingEndTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote !== 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "maker-taker-voted-post-reporting-end-time"
                });
            } else if (customWager.taker !== "" && (timeNowValue > customWager.reportingEndTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote !== 0 && customWager.makerWinVote == customWager.takerWinVote) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "settled-no-dispute"
                });
            } else if (customWager.taker !== "" && (timeNowValue < customWager.endTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote !== 0 && customWager.makerWinVote !== customWager.takerWinVote) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "dispute-pre-end-time"
                });
            } else if (customWager.taker !== "" && (timeNowValue > customWager.endTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote !== 0 && customWager.makerWinVote !== customWager.takerWinVote) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "dispute-post-end-time"
                });
            } else if (customWager.taker !== "" && (timeNowValue > customWager.endTime) && (timeNowValue < customWager.reportingEndTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote !== 0 && customWager.makerWinVote !== customWager.takerWinVote) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "dispute-pre-reporting-end-time"
                });
            } else if (customWager.taker !== "" && (timeNowValue > customWager.endTime) && (timeNowValue > customWager.reportingEndTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote !== 0 && customWager.makerWinVote !== customWager.takerWinVote) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "dispute-post-reporting-end-time"
                });
            } else if (customWager.taker !== "" && customWager.makerWinVote !== 0 && customWager.takerWinVote !== 0 && customWager.makerWinVote !== customWager.takerWinVote && customWager.settled && (timeNowValue > customWager.reportingEndTime) && !customWager.paidOut) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "dispute-settled-not-paid"
                });
            } else if (customWager.taker !== "" && (timeNowValue > customWager.reportingEndTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote !== 0 && customWager.settled && customWager.makerWinVote !== customWager.takerWinVote && customWager.paidOut) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "dispute-settled-paid"
                });
            } else if (customWager.settled) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    maker: true,
                    status: "settled"
                });
            }
        }

        for (let customWager of customWagerListTaken) {
            if (customWager.cancelled) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    taker: true,
                    status: "cancelled"
                });
            } else if ((timeNowValue < customWager.endTime) && (timeNowValue < customWager.reportingEndTime) && customWager.makerWinVote == 0 && customWager.takerWinVote == 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    taker: true,
                    status: "no-votes-pre-end-time-pre-reporting-end-time"
                });
            } else if ((timeNowValue > customWager.endTime) && (timeNowValue < customWager.reportingEndTime) && customWager.makerWinVote == 0 && customWager.takerWinVote == 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    taker: true,
                    status: "no-votes-post-end-time-pre-reporting-end-time"
                });
            } else if ((timeNowValue > customWager.endTime) && (timeNowValue > customWager.reportingEndTime) && customWager.makerWinVote == 0 && customWager.takerWinVote == 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    taker: true,
                    status: "no-votes-post-end-time-post-reporting-end-time"
                });
            } else if ((timeNowValue < customWager.endTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote == 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    taker: true,
                    status: "only-maker-voted-pre-end-time"
                });
            } else if ((timeNowValue < customWager.endTime) && customWager.makerWinVote == 0 && customWager.takerWinVote !== 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    taker: true,
                    status: "only-taker-voted-pre-end-time"
                });
            } else if ((timeNowValue < customWager.endTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote !== 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    taker: true,
                    status: "maker-taker-voted-pre-end-time"
                });
            } else if ((timeNowValue > customWager.endTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote == 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    taker: true,
                    status: "only-maker-voted-post-end-time"
                });
            } else if ((timeNowValue > customWager.endTime) && customWager.makerWinVote == 0 && customWager.takerWinVote !== 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    taker: true,
                    status: "only-taker-voted-post-end-time"
                });
            } else if ((timeNowValue > customWager.endTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote !== 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    taker: true,
                    status: "maker-taker-voted-post-end-time"
                });
            } else if ((timeNowValue > customWager.endTime) && (timeNowValue < customWager.reportingEndTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote == 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    taker: true,
                    status: "only-maker-voted-pre-reporting-end-time"
                });
            } else if ((timeNowValue > customWager.endTime) && (timeNowValue < customWager.reportingEndTime) && customWager.makerWinVote == 0 && customWager.takerWinVote !== 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    taker: true,
                    status: "only-taker-voted-pre-reporting-end-time"
                });
            } else if ((timeNowValue > customWager.endTime) && (timeNowValue < customWager.reportingEndTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote !== 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    taker: true,
                    status: "maker-taker-voted-pre-reporting-end-time"
                });
            } else if ((timeNowValue > customWager.endTime) && (timeNowValue > customWager.reportingEndTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote == 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    taker: true,
                    status: "only-maker-voted-post-reporting-end-time"
                });
            } else if ((timeNowValue > customWager.endTime) && (timeNowValue > customWager.reportingEndTime) && customWager.makerWinVote == 0 && customWager.takerWinVote !== 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    taker: true,
                    status: "only-taker-voted-post-reporting-end-time"
                });
            } else if ((timeNowValue > customWager.endTime) && (timeNowValue > customWager.reportingEndTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote !== 0) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    taker: true,
                    status: "maker-taker-voted-post-reporting-end-time"
                });
            } else if ((timeNowValue > customWager.reportingEndTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote !== 0 && customWager.makerWinVote == customWager.takerWinVote) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    taker: true,
                    status: "settled-no-dispute"
                });
            } else if ((timeNowValue < customWager.endTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote !== 0 && customWager.makerWinVote !== customWager.takerWinVote) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    taker: true,
                    status: "dispute-pre-end-time"
                });
            } else if ((timeNowValue > customWager.endTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote !== 0 && customWager.makerWinVote !== customWager.takerWinVote) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    taker: true,
                    status: "dispute-post-end-time"
                });
            } else if ((timeNowValue > customWager.endTime) && (timeNowValue < customWager.reportingEndTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote !== 0 && customWager.makerWinVote !== customWager.takerWinVote) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    taker: true,
                    status: "dispute-pre-reporting-end-time"
                });
            } else if ((timeNowValue > customWager.endTime) && (timeNowValue > customWager.reportingEndTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote !== 0 && customWager.makerWinVote !== customWager.takerWinVote) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    taker: true,
                    status: "dispute-post-reporting-end-time"
                });
            } else if (customWager.makerWinVote !== 0 && customWager.takerWinVote !== 0 && customWager.makerWinVote !== customWager.takerWinVote && customWager.settled && (timeNowValue > customWager.reportingEndTime) && !customWager.paidOut) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    taker: true,
                    status: "dispute-settled-not-paid"
                });
            } else if ((timeNowValue > customWager.reportingEndTime) && customWager.makerWinVote !== 0 && customWager.takerWinVote !== 0 && customWager.settled && customWager.makerWinVote !== customWager.takerWinVote && customWager.paidOut) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    taker: true,
                    status: "dispute-settled-paid"
                });
            } else if (customWager.settled) {
                customWagersAllObjectList.push({
                    wager: customWager,
                    taker: true,
                    status: "settled"
                });
            }
        }

        this.renderCustomWagersComponents(customWagersAllObjectList);
    }

    renderCustomWagersComponent(wager, status, makerTaker) {
        let time = new Date().getTime() / 1000;
        let startTime = new Date();
        startTime.setTime(wager.startTime * 1000);
        let startTimeString = startTime.toLocaleTimeString() + " - " + startTime.toLocaleDateString();

        return (
            <CustomBetsCard
                key={wager._id}
                status={status}
                wager={wager}
                makerTaker={makerTaker}
                stage={this.renderStage(status, wager, makerTaker)}
            />
        );
    }

    renderCustomWagersComponents(wagerListObj) {
        let customWagerListObj = [];
        let customWagerListObjMade = [];
        let customWagerListObjTaken = [];
        for (let customWager of wagerListObj) {
            if (customWager.maker) {
                customWagerListObjMade.push(this.renderCustomWagersComponent(customWager.wager, customWager.status, "maker"));
                customWagerListObj.push(this.renderCustomWagersComponent(customWager.wager, customWager.status, "maker"));
            } else if (customWager.taker) {
                customWagerListObjTaken.push(this.renderCustomWagersComponent(customWager.wager, customWager.status, "taker"));
                customWagerListObj.push(this.renderCustomWagersComponent(customWager.wager, customWager.status, "taker"));
            }
        }
        this.setState({ renderedMadeCustomWagerList: customWagerListObjMade })
        this.setState({ renderedTakenCustomWagerList: customWagerListObjTaken })
        this.setState({ renderedAllCustomWagerList: customWagerListObj })
    }

    renderStage(status, wager, makerTaker) {

        let stageComponent = [];

        if (status == "untaken-pre-end-time") {
            stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Waiting for match</div>);
            stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options">
                <div className="my-bets-page-cards-wagers-wager-options-cancel"><CancelCustomWager wager={wager} /></div>
            </div>);
        } else if (status == "untaken-post-end-time") {
            stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Never found a match</div>);
            stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options">
                <div className="my-bets-page-cards-wagers-wager-options-cancel"><CancelCustomWager wager={wager} /></div>
            </div>);
        } else if (status == "no-votes-pre-end-time-pre-reporting-end-time") {
            stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Matached</div>);
            stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">
                VOTING STARTS IN <Countdown zeroPadLength={2} date={new Date(wager.endTime).getTime() * 1000}>
                    <span>ENDED, NO TIME</span>
                </Countdown>
            </div>);
        } else if (status == "no-votes-post-end-time-pre-reporting-end-time") {
            stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Reached end time</div>);
            stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">
                <SubmitVote wager={wager} makerTaker={makerTaker} />
            </div>);
        }
        else if (status == "no-votes-post-end-time-post-reporting-end-time") {
            stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Bet has been finalized, if you won click for payout.</div>);
            stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options">
                <div className="my-bets-page-cards-wagers-wager-options-cancel">GET PAID</div>
            </div>);
        } else if (status == "only-maker-voted-pre-reporting-end-time") {
            if (makerTaker == "maker") {
                stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Waiting for opponent to submit their vote</div>);
            } else {
                stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Submit the winner</div>);
                stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options">
                    <div className="my-bets-page-cards-wagers-wager-options-cancel"><SubmitVote wager={wager} /></div>
                </div>);
            }
        }
        else if (status == "only-maker-voted-post-reporting-end-time") {
            if (makerTaker == "maker") {
                stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Bet has been finalized, if you won click for payout.</div>);
                stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options">
                    <div className="my-bets-page-cards-wagers-wager-options-cancel">GET PAID</div>
                </div>);
            } else {
                stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Bet has been finalized, if you won submit vote to initiate payout.</div>);
                stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options">
                    <div className="my-bets-page-cards-wagers-wager-options-cancel"><SubmitVote wager={wager} /></div>
                </div>);
            }
        } else if (status == "only-taker-voted-post-reporting-end-time") {
            if (makerTaker == "taker") {
                stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Waiting for opponent to submit their vote</div>);
            } else {
                stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Submit the winner</div>);
                stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options">
                    <div className="my-bets-page-cards-wagers-wager-options-cancel"><SubmitVote wager={wager} /></div>
                </div>);
            }
        } else if (status == "maker-taker-voted-post-reporting-end-time" || status == "maker-taker-voted-pre-reporting-end-time") {
            stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">BOTH OPPONENTS VOTED</div>);
            stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options">
                <div className="my-bets-page-cards-wagers-wager-options-cancel">SETTLE</div>
            </div>);
        }

        else if (status == "settled-no-dispute" || status == "settled") {
            let takerWon = false;
            let makerWon = false;
            let noWinner = false;

            if (wager.maker == wager.winner) {
                makerWon = true;
            } else if (wager.taker == wager.winner) {
                takerWon = true;
            } else if (wager.taker != wager.winner && wager.maker != wager.winner) {
                noWinner = true;
            }

            if (makerTaker == "taker") {
                if (takerWon) {
                    stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">SETTLED</div>);
                    stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">
                        <span style={{ color: '#27f727' }}>YOU WON</span>
                    </div>);
                } else if (makerWon) {
                    stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">SETTLED</div>);
                    stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage"><span style={{ color: 'rgb(245, 60, 64)' }}>
                        YOU LOST</span>
                    </div>);
                } else if (noWinner) {
                    stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">SETTLED</div>);
                    stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">
                        <span style={{ color: 'rgb(209, 174, 94)' }}>NO WINNER COULD BE DECIDED, YOU WERE REFUNDED</span>
                    </div>);
                }

            } else {
                if (makerWon) {
                    stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">SETTLED</div>);
                    stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">
                        <span style={{ color: '#27f727' }}>YOU WON</span>
                    </div>);
                } else if (takerWon) {
                    stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">SETTLED</div>);
                    stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">
                        <span style={{ color: 'rgb(245, 60, 64)' }}>YOU LOST</span>
                    </div>);
                } else if (noWinner) {
                    stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">SETTLED</div>);
                    stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">
                        <span style={{ color: 'rgb(209, 174, 94)' }}>NO WINNER COULD BE DECIDED, YOU WERE REFUNDED</span>
                    </div>);
                }
            }
        } else {
            stageComponent.push(<div className="my-bets-page-cards-wagers-wager-options-stage">{status}</div>);
        }
        return stageComponent;
    }

    render() {
        const TabPane = Tabs.TabPane;
        return (
            <div className="my-custom-bets">
                <Tabs defaultActiveKey="1">
                    <TabPane tab="All" key="1">
                        <div>
                            {this.state.loadedWagers ? this.state.renderedAllCustomWagerList : null}
                        </div>
                    </TabPane>
                    <TabPane tab="YOU MADE" key="2">
                        <div>
                            {this.state.loadedWagers ? this.state.renderedMadeCustomWagerList : null}
                        </div>
                    </TabPane>
                    <TabPane tab="YOU TAKEN" key="3">
                        <div>{this.state.loadedWagers ? this.state.renderedTakenCustomWagerList : null}</div>
                    </TabPane>
                </Tabs>
            </div>
        );
    }
}

export default inject('store')(observer(MyCustomBetStaging));


// WEBPACK FOOTER //
// ./src/components/layoutComponents/MyCustomBetStaging.js